import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanString'
})
export class CleanStringPipe implements PipeTransform {

  transform(value: string): string {
    const normalizedString = value.normalize('NFD');
    const regex = /[\u0300-\u036f]/g;
    const cleanString = normalizedString.replace(regex, '').replace(/[^a-zA-Z0-9]/g, '');
    return cleanString;
  }

}
